import { apiClient } from '../utils/api-client';
import type { SearchResponse } from '../types/search';

export class SearchService {
  private static instance: SearchService;

  static getInstance(): SearchService {
    if (!SearchService.instance) {
      SearchService.instance = new SearchService();
    }
    return SearchService.instance;
  }

  /**
   * Search across all models
   */
  async search(query: string): Promise<SearchResponse> {
    if (!query.trim()) {
      return {
        data: [],
        meta: {
          query: query,
          total_results: 0
        }
      };
    }


    const response = await apiClient.get(`/api/search?q=${encodeURIComponent(query.trim())}`, {
      requireAuth: false
    });

    if (!response.ok) {
      throw new Error(`Search failed: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();

    return result;
  }
}

export const searchService = SearchService.getInstance();
